<template lang="pug">
  shListData(title="TemporaryStocks History" resolver="temporaryStocksHistory" keyData="_id" component="shTemporaryStock" :history="true")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'TemporaryStocksHistory',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/temporaryStock/TemporaryStocksHistory.vue